var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataURL)?_c('a',{staticClass:"qrcode",attrs:{"href":"#","title":"点击下载面试者简历二维码"},on:{"click":function($event){$event.preventDefault();return _vm.download.apply(null, arguments)}}},[_c('img',{attrs:{"src":_vm.dataURL,"alt":""}}),_c('div',[_vm._v("简历")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }